import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-18">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            强大功能，简单操作
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            从创建到发布，每一步都为你精心设计，让导航页管理变得前所未有的简单
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 md:p-7 rounded-xl bg-background-100 hover:bg-background-200/80 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2.5">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}